var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "@irati/utils/lang";
import HR from "@irati/ui/src/Layout/Hr";
import Toggle from "@irati/ui/src/FormItem/Toggle";
import adminTracking from "@irati-tracking/admin";
import Flex from "@irati/ui/src/Flex";
import IconButton from "../styled/IconButton";
import TagModal from "../TagModal";
import ToggleWrapper from "../styled/ToggleWrapper";
import Tag from "./styled";
var TagListTag = /** @class */ (function (_super) {
    __extends(TagListTag, _super);
    function TagListTag(props) {
        var _this = _super.call(this, props) || this;
        _this.openModal = function () {
            _this.setState({
                showModal: true
            });
        };
        _this.closeModal = function () {
            _this.setState({
                showModal: false
            });
        };
        _this.handleToggle = function () {
            var _a = _this.props, handleToggle = _a.handleToggle, tag = _a.tag, blacklisted = _a.blacklisted;
            adminTracking.changeTagVisibility(tag, blacklisted ? "show" : "hidden");
            var load = handleToggle(tag.uuid).then(function () {
                _this.setState({ load: null });
            });
            _this.setState({ load: load });
        };
        _this.state = {};
        return _this;
    }
    TagListTag.prototype.render = function () {
        var _a = this.props, tag = _a.tag, blacklisted = _a.blacklisted;
        var _b = this.state, showModal = _b.showModal, load = _b.load;
        return (React.createElement(React.Fragment, null,
            React.createElement(Flex, { justifyContent: "space-between", alignItems: "center" },
                React.createElement(Flex, { alignItems: "center", height: "100%" },
                    React.createElement(Tag, { name: tag.name, selected: blacklisted, onClick: function () { } }),
                    React.createElement(IconButton, { icon: "question", inline: true, size: 24, onClick: this.openModal })),
                React.createElement(ToggleWrapper, null,
                    React.createElement(Toggle, { load: load, checked: !blacklisted, icons: false, onClick: this.handleToggle }))),
            blacklisted &&
                React.createElement("p", null,
                    React.createElement(FormattedMessage, { id: "admin.components.perksVisibility.tagListTag.hiddenCategory.text" })),
            React.createElement(HR, null),
            showModal &&
                React.createElement(TagModal, { onHide: this.closeModal, tag: tag })));
    };
    TagListTag.propTypes = {
        tag: PropTypes.object.isRequired,
        blacklisted: PropTypes.bool,
        handleToggle: PropTypes.func.isRequired
    };
    TagListTag.defaultProps = {
        blacklisted: false
    };
    return TagListTag;
}(Component));
export default TagListTag;
